module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[35]400.7260282.woff2";